import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { TooltipContent } from './components/content/Content.mjs';
import { TooltipDefinitionListDescription } from './components/definition-list-description/DefinitionListDescription.mjs';
import { TooltipDefinitionListItem } from './components/definition-list-item/DefinitionListItem.mjs';
import { TooltipDefinitionListTerm } from './components/definition-list-term/DefinitionListTerm.mjs';
import { TooltipDefinitionList } from './components/definition-list/DefinitionList.mjs';
import { TooltipTrigger } from './components/trigger/Trigger.mjs';

function TooltipImpl(props) {
  return /* @__PURE__ */ jsx(TooltipPrimitive.Root, { "data-scope": "tooltip", "data-part": "root", ...props });
}
const Tooltip = Object.assign({}, styled(TooltipImpl), {
  Trigger: styled(TooltipTrigger),
  Content: styled(TooltipContent),
  DefinitionList: styled(TooltipDefinitionList),
  DefinitionListItem: styled(TooltipDefinitionListItem),
  DefinitionListTerm: styled(TooltipDefinitionListTerm),
  DefinitionListDescription: styled(TooltipDefinitionListDescription)
});
Tooltip.displayName = "Tooltip";

export { Tooltip };
//# sourceMappingURL=Tooltip.mjs.map
